export const REDUCER_INDEX = 'institutions_v2'

export const BASE_URL = '/institution'

export const EDIT_URL = `${BASE_URL}/:id/edit`
